import { inject, injectable } from "@launchtray/tsyringe-async";
import { CancellationToken } from "async/CancellationToken";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { TopPanel } from "by/gamefactory/cityversetycoon/scenes/game/components/toppanel/TopPanel";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { ICheckoutHourlyBonusController } from "../controller/ICheckoutHourlyBonusController";
import { CheckoutHourlyBonusPopupView } from "./CheckoutHourlyBonusPopupView";
import { CheckoutHourlyBonusResourcePackage } from "../resources/CheckoutHourlyBonusResourcePackage";
import { DicesResourcePackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/DicesResourcePackage";
import { CheckoutsTooltipResourcePackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CheckoutsTooltipResourcePackage";

export type CheckoutHourlyBonusSceneOptions = {
    isWheel: boolean;
    cancellationToken: CancellationToken;
}

@injectable()
export class CheckoutHourlyBonusPopupScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        dicesResources: DicesResourcePackage,
        checkoutHourlyBonusResources: CheckoutHourlyBonusResourcePackage,
        checkoutsTooltipResources: CheckoutsTooltipResourcePackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ICheckoutHourlyBonusController") checkoutHourlyBonusController: ICheckoutHourlyBonusController,
        @inject("CheckoutHourlyBonusSceneOptions") options: CheckoutHourlyBonusSceneOptions,
        topPanel: TopPanel
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new CheckoutHourlyBonusPopupView(
            pcs,
            options.cancellationToken,
            commonResources,
            dicesResources,
            checkoutHourlyBonusResources,
            checkoutsTooltipResources,
            canvasScaler,
            checkoutHourlyBonusController,
            options.isWheel,
            topPanel
        );
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
